const ukCreateFile: Record<string, { message: string; description: string }> = {
  "ledgerEditor.nameYourFile": {
    message: "Ім'я your file...",
    description: "Placeholder for file name input",
  },
};

export default ukCreateFile;
